export default __webpack_public_path__ + "static/media/icon-check-node.23e6bb36.svg";